import { UISDK } from "@/ui-sdk";
import { Product } from "@/ui-sdk/types";
import { fetchProducts, sortProduct } from "@/utils";
import { getLowTicketSizeRecommendationFromHandles } from "../low-ticket-recommendation/utils/get-low-ticket-size-recommendations";
import { cleanName } from "../product-list/util";

export default async function handleButton(element: HTMLElement, sdk: UISDK) {
  const type = element.getAttribute("data-helium-button-type");
  const handle =
    element.getAttribute("data-helium-product-handle") ??
    element.getAttribute("data-helium-button-product-handle");

  if (!type) {
    console.log("No valid 'data-helium-button-type' attribute found.");
    return;
  }

  if (!handle) {
    console.log("No valid 'data-helium-product-handle' attribute found.");
    return;
  }

  element.addEventListener("click", async (event) => {
    event.preventDefault();
    const key = Date.now();
    sdk.renderButtonDrawer({
      key,
      s: [],
      c: [],
      currentProductHandle: handle,
      type: type === "similar" ? "recommended" : "complete-the-look",
      loading: true,
    });

    const cdn = "https://d21xluao80us9l.cloudfront.net";

    const [product, similarIds, complementaryIds] = await Promise.all([
      window.helium.datastore.getProduct({
        id: handle,
      }),
      window.helium.datastore.getSimilar({ id: handle ?? "" }),
      window.helium.datastore.getComplementary({ id: handle ?? "" }),
    ]);

    const [complementaryStyles, allStyles, lowTicketSize] = await Promise.all([
      fetch(
        `${cdn}/${window.helium.brandData.orgId}/complementary-styles/v3/${handle}/results.json`,
      )
        .then((res) => res.json())
        .catch(() => {
          return {};
        }) as Promise<Record<string, Record<string, string>>>,
      fetch(
        `${cdn}/${window.helium.brandData.orgId}/complementary-styles/styles/${cleanName(product.tags.subcategory.toLowerCase())}.${window.helium.brandData.storeId}.json`,
      )
        .then((res) => res.json())
        .catch(() => []),

      getLowTicketSizeRecommendationFromHandles([
        window.location.pathname.split("/products/").at(1) ??
          "geometrical-design-cotton-bedcover-31",
      ]),
    ]);
    const filteredLowTicketSize = Object.fromEntries(
      Object.entries(lowTicketSize)
        .filter(([_, value]) => value?.complementary?.length > 0)
        .map(([_, value]) => {
          let text = _;
          if (text.toLowerCase() === "handbags") {
            text = "Yoga Mat";
          }
          return [text, value];
        }),
    );
    console.log({ filteredLowTicketSize, lowTicketSize });

    console.info(
      {
        complementaryStyles,
        allStyles,
        filteredLowTicketSize,
        f: Object.entries(allStyles[0].otherSubcategoryPositions)
          .filter(
            (e: any) =>
              e[1].isAnchorSubcategory ||
              e[1].subcategory.toLowerCase() ===
                product.tags.subcategory.toLowerCase(),
          )
          .filter(Boolean),
      },
      " dusaan 123",
    );

    const currentPosition = Object.entries(
      allStyles[0].otherSubcategoryPositions,
    )
      .filter((e: any) => true)
      .filter(Boolean)[0][0];

    const complementaryStylesWithProduct = JSON.parse(
      JSON.stringify(complementaryStyles),
    );

    const totalIds = [];

    for (const style in complementaryStyles) {
      const prods = Object.values(complementaryStyles[style]);

      totalIds.push(...prods);
    }

    await Promise.all(
      totalIds.map(
        (id) =>
          window.helium.datastore
            .getProduct({ id })
            .then((res) => res.details) as Promise<Product>,
      ),
    );

    // for (const style in complementaryStylesWithProduct) {
    //   const subcategories = complementaryStylesWithProduct[style];
    //   subcategories.forEach(async (subcategory, index) => {
    //     // const index = complementaryStylesWithProduct[style].findIndex(
    //     //   (s) => s.subcategory === subcategory.subcategory,
    //     // );

    //     complementaryStylesWithProduct[style][index].results =
    //       complementaryStylesWithProduct[style][index].results.map(
    //         (e) => window.helium.datastore.memory.product[e].details,
    //       );
    //   });
    //   // for (const subcategory of subcategories) {

    //   // }
    // }
    console.log(
      { complementaryStylesWithProduct, complementaryStyles },
      "lowTicketSize",
    );
    const sortedSimilarIds = await sortProduct({
      productsIds: similarIds,
    });

    const isPairItWithEmpty =
      Object.keys(complementaryIds).length === 0 ||
      Object.values(complementaryIds).every(
        (subcategory) => Object.values(subcategory).flat().length === 0,
      );
    const [similarProducts, complementaryProducts] = await Promise.all([
      await fetchProducts(sortedSimilarIds),
      isPairItWithEmpty
        ? []
        : Object.fromEntries(
            await Promise.all(
              Object.entries(complementaryIds).map(
                async ([category, subcategories]) => {
                  if (Array.isArray(complementaryIds[category])) {
                    const products = await fetchProducts(
                      complementaryIds[category].slice(0, 5),
                    );
                    if (products.length === 0) return [category, {}];
                    return [
                      category,
                      {
                        complementary: products,
                      },
                    ];
                  }
                  const resolvedSubcategories = Object.fromEntries(
                    await Promise.all(
                      Object.entries(subcategories).map(
                        async ([subcategory, ids]) => {
                          return [subcategory, await fetchProducts(ids)];
                        },
                      ),
                    ),
                  );

                  return [category, resolvedSubcategories];
                },
              ),
            ),
          ),
    ]);

    // for (const style in complementaryStylesWithProduct) {
    //   const indexOfCurrentProduct = complementaryStylesWithProduct[
    //     style
    //   ].findIndex((e) => e.position === currentPosition);

    //   if (indexOfCurrentProduct !== -1) {
    //     complementaryStylesWithProduct[style][indexOfCurrentProduct] = {
    //       ...complementaryStylesWithProduct[style][indexOfCurrentProduct],
    //       results: [handle],
    //       subcategory: product.tags.subcategory.toLowerCase(),
    //       fixed: true,
    //     };
    //   }
    // }

    sdk.renderButtonDrawer({
      key,
      s: similarProducts,
      c: complementaryProducts,
      currentProductHandle: handle,
      type: type === "similar" ? "recommended" : "complete-the-look",
      loading: false,
      complementaryStyles: complementaryStylesWithProduct,
      currentProductPosition: currentPosition,
      lowTicketSize: filteredLowTicketSize,
    });
  });
}
